import forge from 'mappersmith';
import EncodeJson from 'mappersmith/middlewares/encode-json';
import GlobalErrorHandler, {
  setErrorHandler,
} from 'mappersmith/middleware/global-error-handler';
import Manifest from './Manifest';
import store from '../store';
import history from '../history';
import { logout, refreshAccessToken } from '../actions/auth';
import { configs } from 'mappersmith';
import { STATUS } from '../constants';
import Cookies from 'cookies-js';

configs.maxMiddlewareStackExecutionAllowed = 4;

function getRedirectURL(pathname, queryParams) {
  let redirectTo = '/login';
  if (
    !pathname.includes('login') &&
    pathname !== '/' &&
    pathname !== '/reset'
  ) {
    const next = encodeURIComponent(pathname + queryParams);
    redirectTo = `${redirectTo}?next=${next}`;
  }
  return redirectTo;
}

setErrorHandler((response) => {
  let refreshTokenJSON = JSON.parse(
    Cookies.get('persist:refreshToken') || '{}',
  );
  let refresh_token = refreshTokenJSON?.refreshToken?.replaceAll('"', '');

  const tokenParts = refresh_token
    ? JSON.parse(atob(refresh_token?.split('.')[1]))
    : '';
  const now = Math.ceil(Date.now() / 1000);

  const state = store?.getState();
  const { token } = state?.auth;
  const path = window.location.pathname;

  if (
    (!token || !refresh_token) &&
    //&& response.responseStatus === 401
    !window.location.href.includes('/reset') &&
    !window.location.href.includes('/reset/confirm') &&
    !window.location.href.includes('/extend-subscription/confirm') &&
    !window.location.href.includes('/register')
    //!pathsToIgnore.includes(response?.originalRequest?.methodDescriptor?.path)
  ) {
    if (path === '/login' || path === '/register') {
      return;
    }
    const redirectTo = getRedirectURL(path, window.location.search);
    history.push(redirectTo);
    //return true;
  }
  if (
    tokenParts?.exp < now &&
    !window.location.href.includes('/reset/confirm')
  ) {
    const redirectTo = getRedirectURL(path, window.location.search);
    store.dispatch(logout(redirectTo));
  }

  // if (state.auth.loginStatus === STATUS.ERROR) {
  //   history.push('/login');
  // }

  return false;
});

const AuthMiddleware = () => {
  //if(refresh_token){
  //const tokenParts = JSON.parse(atob(refresh_token?.split('.')[1]));
  //const now = Math.ceil(Date.now() / 1000);

  let isAlreadyFetchingAccessToken = false;

  return () => ({
    request(request) {
      const state = store?.getState();
      const { token } = state?.auth;
      if (state?.auth?.tokenStatus !== STATUS?.LOADING) {
        setTimeout(() => {
          isAlreadyFetchingAccessToken = false;
        }, 1000);

        return request?.enhance({
          headers: {
            Authorization: `Bearer ${JSON?.parse(
              Cookies?.get('persist:token'),
            )?.token?.replaceAll('"', '')}`,
          },
        });
      }
    },
    response(next, renew) {
      const state = store?.getState();
      const { token } = state?.auth;

      return next()?.catch((response) => {
        if (
          response?.status() === 401 &&
          !isAlreadyFetchingAccessToken &&
          JSON?.parse(Cookies?.get('persist:token'))?.token?.replaceAll('"', '')
        ) {
          // token expired
          isAlreadyFetchingAccessToken = true;
          let refreshTokenJSON = JSON.parse(
            Cookies.get('persist:refreshToken') || '{}',
          );
          let refresh_token = refreshTokenJSON?.refreshToken?.replaceAll(
            '"',
            '',
          );
          let refreshTOKEN = state?.auth?.refreshToken
            ? state?.auth?.refreshToken
            : refresh_token;

          store.dispatch(
            refreshAccessToken({
              refresh: refreshTOKEN,
            }),
          );

          //access_token = null;

          return renew();
        }
        if (response?.status() === 401) {
          return next();
        } else {
          return response;
        }
      });
    },
  });
};

const CSRFMiddleware = () => ({
  request(request) {
    const csrftoken = Cookies?.get('csrftoken');

    return request?.enhance({
      headers: {
        'X-CSRFToken': csrftoken,
      },
    });
  },
});

const AuthToken = AuthMiddleware();

function mockEncoder(string) {
  //So we don't encode the query strings, as it's default by https://github.com/tulios/mappersmith/blob/master/README.md#-parameters
  return string;
}

export const authClient = forge({
  ...Manifest,
  parameterEncoder: mockEncoder,
  middlewares: [AuthToken, EncodeJson, GlobalErrorHandler],
});

// export const authClientFormData = forge({
//     ...Manifest,
//     middlewares: [Retry(retryConfigs), AuthMiddleware, GlobalErrorHandler],
// });

export const anonClient = forge({
  ...Manifest,
  middlewares: [CSRFMiddleware, EncodeJson, GlobalErrorHandler],
});

export const createFakeResponse = (data) => ({
  data: () => data,
});
